import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=713a0e20&scoped=true"
import script from "./Product.vue?vue&type=script&lang=js"
export * from "./Product.vue?vue&type=script&lang=js"
import style0 from "./Product.vue?vue&type=style&index=0&id=713a0e20&prod&scoped=true&lang=css"
import style1 from "./Product.vue?vue&type=style&index=1&id=713a0e20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713a0e20",
  null
  
)

export default component.exports